/* eslint-disable linebreak-style */
import { Box, Typography, Button, Card, CardContent, Alert, Stack } from '@mui/material';
import React from 'react';

type Link = {
  text: string;
  url: string;
};

interface Body {
  title?: string | null;
  links?: Link[] | null;
  content?: React.ReactNode;
  subtext?: string;
  notes?: string;
  titleColor?: string | null;
}

interface MigrationSectionProps {
  body: Body[];
}

export function MigrationSection({ body }: Readonly<MigrationSectionProps>) {
  return (
    <Alert
      severity="info"
      variant="outlined"
      sx={ {
        backgroundColor: '#f9fbfc',
        borderRadius: 2,
        maxWidth: '900px',
        mx: 'auto',
        p: 4,
        border: '1px solid #e0e0e0',
      } }
    >
      <Stack spacing={4}>
        {body.map(({ title, links, subtext,
          content, titleColor }, index) => (
          <Box
            key={index}
            sx={ {
              borderTop: index !== 0 ? '1px solid #eee' : 'none',
              pt: index !== 0 ? 3 : 0,
            } }
          >
            {title && (
              <Typography
                variant="h6"
                textAlign="center"
                fontWeight="bold"
                color={titleColor ?? 'primary'}
                align="left"
                sx={ { mb: 2 } }
              >
                {title}
              </Typography>
            )}

            {links && (
              <Box mb={2} display="flex" justifyContent="center" gap={2} flexWrap="wrap">
                {links.map((link) => (
                  <Button
                    key={link.url}
                    variant="contained"
                    color="primary"
                    href={link.url}
                    sx={ {
                      textTransform: 'uppercase',
                      fontWeight: 600,
                      fontSize: '12px',
                      px: 4,
                    } }
                  >
                    {link.text}
                  </Button>
                ))}
              </Box>
            )}

            {subtext && (
              <Typography variant="subtitle1" fontWeight="bold" color="primary" sx={ { mb: 1 } }>
                {subtext}
              </Typography>
            )}

            {content && (
              <Box sx={ { color: '#444' } }>
                {content}
              </Box>
            )}
          </Box>
        ))}

        <Card variant="outlined" sx={ { borderRadius: 2 } }>
          <CardContent>
            <Typography
              variant="body2"
              align="center"
              sx={ { fontStyle: 'italic', color: '#666' } }
            >
          If you are in need of further assistance, reach out to your client service representative.
            </Typography>
          </CardContent>
        </Card>
      </Stack>
    </Alert>
  );
}

